
        var result = require("!!../../../node_modules/css-loader/dist/cjs.js!./theme.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    